/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rich_Warm_Bear_RoamInputs */

const en_rich_warm_bear_roam = /** @type {(inputs: Rich_Warm_Bear_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will restore the report to this version. Current unsaved changes will be lost.`)
};

const de_rich_warm_bear_roam = /** @type {(inputs: Rich_Warm_Bear_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bericht wird auf diese Version zurückgesetzt. Nicht gespeicherte Änderungen gehen verloren.`)
};

/**
* | output |
* | --- |
* | "This will restore the report to this version. Current unsaved changes will be lost." |
*
* @param {Rich_Warm_Bear_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_warm_bear_roam = /** @type {((inputs?: Rich_Warm_Bear_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Warm_Bear_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_warm_bear_roam(inputs)
	return de_rich_warm_bear_roam(inputs)
});